import styled from 'styled-components';
import ModalBody from './ModalBody';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import Input from '../Input';

const ModalContent = styled.div`
  position: relative;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: ${(props) => props.theme.whiteColor};
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.2);
  outline: 0;
  &.default-popup{
    background: ${(props) => props.theme.whiteColor};
    border-radius: 8px;
    border: none;
    ${ModalHeader}{
      background: ${(props) => props.theme.lightWhite};
      border-radius: 8px 8px 0px 0px;
      h5{
        font-size: 20px;
        display: inline-block;
        margin: 0;
        text-transform: capitalize;
        font-weight: bold;
      }
      button{
        position: absolute;
        z-index:9;
        right:5px;
        top:1px;
        border-radius:50%;
        color:#5d5d5d;
      }
    }
    ${ModalBody}{
      .formElement{
        padding: 30px 30px 0px 30px;
        margin-top: 40px;
        ${Input}{
          width:100%;
          margin-bottom:20px;
        }
        textarea{
          width:100%;
          height:75px;
        }
      }
      .common{
        padding: 10px;
        text-align: center;
        margin: 0;
        form{
          margin-top:20px;
        }
        
      }
    }
    ${ModalFooter}{
      padding: 0px 30px 30px 30px;
      border-radius: 0px 0px 8px 8px;
      button{
        background:${(props) => props.theme.primaryColor};
        color:${(props) => props.theme.whiteColor};
      }
    }
  }
  &.default{
    background:${(props) => props.theme.whiteColor};
    ${ModalHeader}{
      padding:0px;
      h5{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        // width: 100%;
        top: 35px;
        font-size:19px;
      }
      button{
        position: absolute;
        z-index:9;
        right:15px;
        top:15px;
        border-radius:50%;
        color:#5d5d5d;
      }
    }
    ${ModalBody}{
      .formElement{
        padding: 30px 30px 0px 30px;
        margin-top: 40px;
        ${Input}{
          width:100%;
          margin-bottom:20px;
        }
        textarea{
          width:100%;
          height:75px;
        }
      }
      .common{
        padding: 10px;
        text-align: center;
        margin: 0;
        form{
          margin-top:20px;
        }
        
      }
    }
    ${ModalFooter}{
      padding: 0px 30px 30px 30px;
      button{
        background:${(props) => props.theme.primaryColor};
        color:${(props) => props.theme.whiteColor};
      }
    }
  }
  &.videoPopup{
    ${ModalBody}{
      padding:0px;
      background:${(props) => props.theme.transparentColor};
      iframe{
        min-height:500px;
        }
      }
    ${ModalHeader}{
      padding:0px;
      h5{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        // width: 100%;
        top: 35px;
        font-size:19px;
      }
      button{
        position: absolute;
        z-index:9;
        right: -15px;
        top: -15px;
        border-radius:50%;
        color:#5d5d5d;
        background:${(props) => props.theme.whiteColor};
      }
    }
  }
  &.without-header{
    background:${(props) => props.theme.whiteColor};
    ${ModalHeader}{
      padding:0px;
      h5{
        display:none;
      }
      button{
        position: absolute;
        z-index:9;
        right:15px;
        top:15px;
        border-radius:50%;
        color:#5d5d5d;
      }
    }
    ${ModalBody}{
      
    }
    ${ModalFooter}{
      
    }
  }
  &.getintouch{
    margin-top: 20%;
    ${ModalHeader}{
      padding:0px;
      h5{
        display:none;
      }
      button{
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 9;
        width: 30px;
        height: 30px;
        border-right: 0px;
        border-top: 0px;
      }
    }
    ${ModalBody}{
      padding:0px;
    }
    ${ModalFooter}{
      
    }
  }
`;

export default ModalContent;



// WEBPACK FOOTER //
// client/components/Modal/ModalContent.js